/*********************************************/
/* JavaScript for http://www.cornelliron.com */
/*********************************************/

// Begin Regional Map Scripts
function changeTerrUS(elem, e) {
	$(".rmInfo").each(function () { $(this).hide(); });
	$('.intl #intlmap').attr("src", $('.intl #intlmap').attr("src").substring(0, $('.intl #intlmap').attr("src").lastIndexOf("/")) + "/intlmap.png");
	var rmClass = "." + $(elem).attr("name");
	$('.usa #basemap').attr("src", $('.usa #basemap').attr("src").substring(0, $('.usa #basemap').attr("src").lastIndexOf("/")) + "/" + $(elem).attr("name") + ".png");
	$(rmClass).show();
}
function changeTerrIntl(elem, e) {
	$(".rmInfo").each(function () { $(this).hide(); });
	$('.usa #basemap').attr("src", $('.usa #basemap').attr("src").substring(0, $('.usa #basemap').attr("src").lastIndexOf("/")) + "/base-map.png");
	var rmClass = "." + $(elem).attr("name");
	$('.intl #intlmap').attr("src", $('.intl #intlmap').attr("src").substring(0, $('.intl #intlmap').attr("src").lastIndexOf("/")) + "/" + $(elem).attr("name") + ".png");
	$(rmClass).show();
}

function showUsMap() {
	$(".intl").css("visibility", "hidden");
	$(".intl").css("height", "0px");
	$(".intl").css("overflow", "hidden");
	$(".intl").css("display", "none");
	$(".usa").css("visibility", "visible");
	$(".usa").css("height", "");
	$(".usa").css("overflow", "");
	$(".usa").css("display", "block");
}

var intldone = false;

function showIntlMap() {
	$(".usa").css("visibility", "hidden");
	$(".usa").css("height", "0px");
	$(".usa").css("overflow", "hidden");
	$(".usa").css("display", "hidden");
	$(".intl").css("visibility", "visible");
	$(".intl").css("height", "");
	$(".intl").css("overflow", "");
	$(".intl").css("display", "block");
	if (!intldone) {
		$('img#intlmap').ImageMapResize({ origImageWidth: $('img#intlmap')[0].naturalWidth });
		intldone = true;
	}
}
// End Regional Map Scripts

function setCookie(cookieName) {
	document.cookie = cookieName + "=true;";
}

function getCookie(name) {
	var cookies = document.cookie.split(';');
	for (var i = 0; i < cookies.length; ++i) {
		var pair = cookies[i].trim().split('=');
		if (pair[0] == name)
			return pair[1];
	}
}


$(document).ready(function(){
	//if(window.location.href.indexOf("cooksondoor.com/find-a-dealer") > -1 && window.location.href.indexOf("www") < 0)
	//	location.replace("http://www.cooksondoor.com/find-a-dealer");
	//else if(window.location.href.indexOf("cornelliron.com/find-a-dealer") > -1 && window.location.href.indexOf("www") < 0)
	//	location.replace("http://www.cornelliron.com/find-a-dealer");
	$("a.btn-cornell").each(function(){
        $(this).parent().addClass("centerbtn");
        //Want to keep sibling buttons the same width
        if ($(this).siblings('a.btn-cornell').length >= 1) {
            this.style.width = '100%';
        }
	});
	
	$(".cooklink").each(function(){
		var href = $(this).attr("href");
		href = "http://assets.cooksondoor.com" + href;
		$(this).attr("href", href);
	});
	
	$(".usa area").click(function(e){
	changeTerrUS(this, e);
	});
	$(".intl area").click(function(e){
	changeTerrIntl(this, e);
	});

	$("#btnusa").click(function () {
		showUsMap();
	});
	$("#btnintl").click(function () {
		showIntlMap();
	});
});

	// Open dealer websites in a new window
$(document).ajaxComplete(function(){
	if($(".proximlocator").length > 0) {
		$(".proximlocator .infocolumn .insidecolumn .afterrequest .dealer .address div a").each(function(){
			if($(this).attr("target") != "_blank" && $(this).attr("href").indexOf("mailto") < 0)
				$(this).attr("target","_blank");
		});
	}
});